var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWork(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 19.5C3 17.2909 4.79086 15.5 7 15.5H57C59.2091 15.5 61 17.2909 61 19.5V51.5C61 53.7091 59.2091 55.5 57 55.5H7C4.79086 55.5 3 53.7091 3 51.5V19.5Z",
    fill: "#D7BDFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 19.5C3 17.2909 4.79086 15.5 7 15.5H57C59.2091 15.5 61 17.2909 61 19.5V27.5C61 29.7091 59.2091 31.5 57 31.5H7C4.79086 31.5 3 29.7091 3 27.5V19.5Z",
    fill: "#AF7BFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 27.5C15 26.3954 15.8954 25.5 17 25.5H19C20.1046 25.5 21 26.3954 21 27.5V35.5C21 36.6046 20.1046 37.5 19 37.5H17C15.8954 37.5 15 36.6046 15 35.5V27.5Z",
    fill: "#AF7BFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43 27.5C43 26.3954 43.8954 25.5 45 25.5H47C48.1046 25.5 49 26.3954 49 27.5V35.5C49 36.6046 48.1046 37.5 47 37.5H45C43.8954 37.5 43 36.6046 43 35.5V27.5Z",
    fill: "#AF7BFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43 27.5C43 26.3954 43.8954 25.5 45 25.5H47C48.1046 25.5 49 26.3954 49 27.5V31.5H43V27.5Z",
    fill: "#D7BDFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15 27.5C15 26.3954 15.8954 25.5 17 25.5H19C20.1046 25.5 21 26.3954 21 27.5V31.5H15V27.5Z",
    fill: "#D7BDFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M40 15.5L40 12.5C40 10.2909 38.2091 8.5 36 8.5L28 8.5C25.7909 8.5 24 10.2909 24 12.5L24 15.5",
    stroke: "#D7BDFF",
    strokeWidth: 4
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWork);
export default __webpack_public_path__ + "static/media/Work.0f8bbf2ca0d283f6c1dd651b3c228228.svg";
export { ForwardRef as ReactComponent };